import React, { useState } from 'react';
import StoreSearch from '../../../components/StoreSearch';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { Button } from 'reactstrap';

const ADD_STORE_TO_INVOICE_COLLECTION = gql`
  mutation AddStoreToInvoiceCollection(
    $invoiceCollectionId: ID!
    $storeId: ID!
  ) {
    addStoreToInvoiceCollection(
      invoice_collection_id: $invoiceCollectionId
      store_id: $storeId
    ) {
      id
      stores {
        id
        name
      }
    }
  }
`;

export function AddNewStoreToInvoiceCollection({
  invoiceCollectionId,
}: {
  invoiceCollectionId: string;
}) {
  const [addStore, { data, loading, error }] = useMutation(
    ADD_STORE_TO_INVOICE_COLLECTION,
  );
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [selectedStore, setSelectedStore] = useState({ storeId: '', name: '' });

  const handleStoreSelection = (
    storeUuid: string,
    storeId: string,
    name: string,
  ) => {
    setSelectedStore({ storeId, name });
  };

  const handleSubmit = () => {
    if (!selectedStore.storeId)
      return setFeedbackMessage('Please select a store first');

    addStore({
      variables: { invoiceCollectionId, storeId: selectedStore.storeId },
    })
      .then(() =>
        setFeedbackMessage(
          `Store ${selectedStore.name} has been added successfully!`,
        ),
      )
      .catch((err) => setFeedbackMessage(`Error adding store: ${err.message}`));
  };

  return (
    <div>
      <h4>Add a new store</h4>

      <StoreSearch setStoreInfo={handleStoreSelection} />

      <br />
      <Button
        variant="primary"
        onClick={handleSubmit}
        disabled={!selectedStore.storeId || loading}
      >
        {selectedStore.name
          ? `Add ${selectedStore.name} to Invoice Collection`
          : 'Select a Store to Add'}
      </Button>
      <br />
      {feedbackMessage && !error && <div>{feedbackMessage}</div>}
      {loading && <div>Loading...</div>}
      {error && <div>Error! {error.message}</div>}
    </div>
  );
}
